<template>
  <div class="nav-bar">
    <div class="read-only">
      <div>
        <b-button v-if="this.user && this.user.Permissions.editarpap.allowed" id='btLock' class="lockgroup" size="sm"
          @click="changeEditMode()">
          <b-icon v-if="!this.lock" class="lockIcon" icon="lock" aria-hidden="true"></b-icon>
          <b-icon v-else icon="unlock" class="lockIcon" aria-hidden="true"></b-icon>
        </b-button>
      </div>
      <div v-if="this.lock">
        <b-icon class="actionSimulation-navbar tools-nodes" :title="$t('papNavbarToolsIcon')" @click="openToolsNode"
          icon="tools"></b-icon>
      </div>
    </div>

    <div v-if="type == 'PAP'" class="scenarioInfo" :title="scenarioName">{{ $t('papNavbarScenery') }} {{ scenarioName }}
    </div>

    <div v-if="scenarioPeriod != 'null' && type == 'PCP'" class="referenceInfo" :title="scenarioPeriod">
      {{ $t('papNavbarReference') }} {{ scenarioPeriod }}</div>
    <div v-if="type == 'PCP'" class="ref-select referenceInfoYear">
      <p class="mr-2 yearText noselect">Ano Base</p>
      <b-form-select v-model="yearSelected" class="select-view noselect">
        <template #first>
          <b-form-select-option :value="null">Selecione o ano</b-form-select-option>
        </template>
        <b-form-select-option v-for="year in plansWithBaseYearsAndRevision" :key="year.id" :value="year.baseYear">{{
          year.baseYear
        }}</b-form-select-option>
      </b-form-select>
      <p class="mr-2 ml-2 yearText noselect">Revisão</p>
      <b-form-select v-model="revisionSelected" class="select-view noselect mr-2">
        <template #first>
          <b-form-select-option :value="null">Selecione a revisão</b-form-select-option>
        </template>
        <b-form-select-option v-for="revision in revisions" :key="revision.id" :value="revision">{{
          revision.description
        }}</b-form-select-option>
      </b-form-select>
    </div>
    <div>
      <b-icon @click="() => changeArea('PAP')" class="actionSimulation-navbar back-pap" :title="$t('papHover')"
        icon="house-door-fill"></b-icon>
    </div>
    <div>
      <img @click="() => changeArea('Balanço Hídrico')" id="hidrico" class="noselect" src="@/assets/hidrico.png"
        :title="$t('hydricBalance')" alt="Balanço hídrico" />
    </div>
    <div>
      <img @click="() => changeArea('Ocupações')" id="ocupacao" class="noselect" src="@/assets/ocupacao.png"
        :title="$t('occupations')" alt="Ocupações" />
    </div>
    <div>
      <img id="" class="noselect" src="@/assets/regressar.png" :title="$t('return')" alt="Retornar" @click="backFlow" />
    </div>
    <div>
      <b-icon @click="play" class="actionSimulation-navbar play-simulation" :title="$t('executeSimulationButtom')"
        icon="play-fill"></b-icon>
    </div>
    <div>
      <img @click="goalSeek" id="atingirmeta" class="noselect" src="@/assets/atingirmeta.png"
        :title="$t('achieveGoals')" alt="Atingir Metas" />
    </div>
    <div>
      <img @click="sensitivityAnalysis" id="analisesensibilidade" class="noselect"
        src="@/assets/analisesensibilidade.png" :title="$t('sensitivityAnalysis')" alt="Análise de Sensibilidade" />
    </div>

    <div class="ref-select">
      <p class="mr-2 noselect">{{ $t('visualization') }}</p>
      <b-form-select v-model="attrSelected" class="select-view noselect">
        <template #first>
          <b-form-select-option :value="null">{{ $t('pattern') }}</b-form-select-option>
        </template>
        <b-form-select-option value="W">{{ $t('massFlow') }}</b-form-select-option>
        <b-form-select-option value="WVol">{{ $t('volumetricFlow') }}</b-form-select-option>
        <b-form-select-option value="P">{{ $t('pressure') }}</b-form-select-option>
        <b-form-select-option value="T">{{ $t('temperature') }}</b-form-select-option>
        <b-form-select-option value="POL">{{ $t('pol') }}</b-form-select-option>
        <b-form-select-option value="ART">{{ $t('art') }}</b-form-select-option>
        <b-form-select-option value="AR">{{ $t('ar') }}</b-form-select-option>
        <b-form-select-option value="brix">{{ $t('brix') }}</b-form-select-option>
        <b-form-select-option value="pureza">{{ $t('purity') }}</b-form-select-option>
        <b-form-select-option value="pot">{{ $t('potency') }}</b-form-select-option>
      </b-form-select>
    </div>

    <FormOperation :dialogVisibleShow="showDialogReadOnly">
    </FormOperation>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { onEventBuss, urlMainAPI } from '../../global';
import FormOperation from "../flowchart/dialogForm/FormOperation"
import axios from "axios";

export default {
  name: "PapNavBar",
  computed: mapState(["user", "updateModeEditor", "scenarioName"]),

  props: [
    "editorMode",
    "scenarioPeriod",
    "yearPeriod",
    "revisionPeriod",
    "type",
    "updateInfoPCP"
  ],

  components: {
    FormOperation,
  },

  data() {
    return {
      lock: this.editorMode,
      ref: "Padrão",
      attrSelected: null,
      clicked: 0,
      showDialogReadOnly: false,
      referenceMonth: null,
      yearSelected: null,
      revisionSelected: null,
      plansWithBaseYearsAndRevision: null,
      revisions: []
    }
  },
  watch: {
    attrSelected(value) {
      this.$emit("attrSelected", value)
    },
    yearSelected(value) {
      this.revisions = this.plansWithBaseYearsAndRevision.find(p => p.baseYear == value).revisions
      this.revisionSelected = null
    },
    revisionSelected(value) {
      if (value) {
        this.$emit("yearPeriod", this.yearSelected)
        this.$emit("revisionPeriod", value)
      }
    },
    async updateInfoPCP(value) {
      if (value != null) {
        let oldValue = this.yearSelected;
        await this.loadBaseYears()
        this.revisions = this.plansWithBaseYearsAndRevision.find(p => p.baseYear == oldValue).revisions
        this.yearSelected = oldValue;
        this.revisionSelected = this.revisions.find(b => b.id == value.planId)
      }
    }
  },

  methods: {
    changeEditMode() {
      this.lock = !this.lock
      this.$emit("editorMode", this.lock);
    },

    backFlow() {
      this.clicked++;
      this.$emit("returnClicked", this.clicked);
    },

    play() {
      this.clicked++;
      this.attrSelected = null;
      this.$emit("executeSimulation", this.clicked);
    },

    goalSeek() {
      this.clicked++
      this.$emit("openGoalSeek", this.clicked);
    },

    sensitivityAnalysis() {
      this.clicked++
      this.$emit("openSensitivityAnalysis", this.clicked);
    },

    changeArea(value) {
      this.clicked++
      this.$emit("flowChartTo", {
        area: value,
        clicked: this.clicked
      });
    },

    openToolsNode() {
      this.showDialogReadOnly++
    },

    async loadBaseYears() {
      const url = `${urlMainAPI}/getproductionplanswithrevisionsbyyear`;
      await axios
        .get(url)
        .then((res) => {
          this.plansWithBaseYearsAndRevision = res.data;
        })
        .catch();
    },

    mounted() {
      onEventBuss("OpentToolsNode", this.openToolsNode)
    },

    destroyed() {
      this.lock = false;
    },
  },

  async created() {
    await this.loadBaseYears();
  }
}
</script>

<style>
.nav-bar>div>svg.play-simulation {
  margin-left: 4px;
  font-size: 36px;
  cursor: pointer;
  color: #ff5f00;
}

.nav-bar>div>div>svg.tools-nodes,
.nav-bar>div>svg.back-pap {
  margin-left: 4px;
  cursor: pointer;
  color: #ff5f00;
  font-size: 24px;
}

.nav-bar>div>div>svg.tools-nodes {
  font-size: 19px;
  position: absolute;
  top: 5px;
}

.nav-bar>div>div>svg.tools-nodes:hover,
.nav-bar>div>svg.back-pap:hover,
.nav-bar>div>svg.play-simulation:hover {
  transition-duration: 500ms;
}

.nav-bar>div>div>svg.tools-nodes:active,
.nav-bar>div>svg.back-pap:active,
.nav-bar>div>svg.play-simulation:active {
  color: #ff5f0050;
  transition-duration: 50ms;
}
</style>

<style scoped>
.nav-bar {
  margin: 8px;
  display: flex;
  align-items: center;
  justify-content: right;
  position: relative;
  top: -2px;
  left: -10px;
  width: 100%;
  height: 30px;
}

.nav-bar>div:first-child {
  width: 100%;
  justify-content: flex-start;
}

.nav-bar>div:last-child {
  display: flex;
  justify-items: center;
  align-items: center;
  min-width: 224px;
}

.nav-bar>div {
  padding-left: 10px;
}

.nav-bar>div>img {
  width: 23px;
  height: 23px;
  cursor: pointer;
}

.scenarioInfo {
  width: 250px;
  min-width: 250px;
  max-width: 500px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis !important;
  font-size: 0.85rem;
  text-align: end;
}

.referenceInfo {
  width: 330px;
  margin-top: 2px;
  white-space: nowrap;
  text-overflow: ellipsis !important;
  overflow: hidden;
  font-size: 0.85rem;
  text-align: center;
  color: #ff5f00;
}

.referenceInfoYear {
  font-size: 0.85rem;
  color: #ff5f00;
  white-space: nowrap;
  text-overflow: ellipsis !important;
  text-align: center;
}

#analisesensibilidade {
  width: 30px;
  height: 32px;
}

#eficiencia {
  width: 37px;
  height: 23px;
}

#hidrico {
  width: 27px;
  height: 25px;
}

#ocupacao {
  width: 27px;
  height: 30px;
}

.nav-bar>div>img:active {
  opacity: 0.5;
}

.nav-bar>div>p {
  margin: 0;
}

.yearText {
  margin: 0;
  margin-top: 2px !important;
}

#tools-nodes,
.lockgroup,
.lockIcon {
  color: #ff5f00 !important;
  font-size: 17px;
  background-color: #0000;
  border: none;
  outline: none;
}

#tools-nodes {
  font-size: 21px;
}

#tools-nodes:hover {
  transition-duration: 500ms;
}

#tools-nodes:active {
  color: #ff5f0050;
  transition-duration: 50ms;
}

.lockgroup:focus {
  box-shadow: none;
}

.lockgroup:active {
  color: #000;
  background-color: #0000;
}

.lockIcon {
  color: red;
}

.select-view {
  min-width: 100px;
}

.read-only {
  display: flex;
  justify-content: center;
  align-items: baseline;
}

.ref-select {
  display: flex;
}

.ref-select>p,
.ref-select select {
  margin: 0;
  font-size: 0.85rem;
}

.ref-select select {
  height: 23px;
  padding: 1px 5px;
  min-width: 138px;
}

@media only screen and (max-width: 817px) {
  .scenarioInfo {
    display: none !important;
  }
}

@media only screen and (max-width: 605px) {
  div.ref-select {
    display: none !important;
  }
}

@media only screen and (max-width: 321px) {

  #atingirmeta,
  #analisesensibilidade,
  #eficiencia,
  #hidrico,
  #ocupacao,
  div.ref-select {
    display: none !important;
  }

  .nav-bar>div:first-child {
    width: calc(100% - 70px);
  }
}
</style>
